export default {
  lockEditAllMessage: '編集モードでは他の機能は使用できません',
}
